import { render, staticRenderFns } from "./LoadingReportView.vue?vue&type=template&id=b1b4122a&"
import script from "./LoadingReportView.vue?vue&type=script&lang=ts&"
export * from "./LoadingReportView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports